import axios from "axios";
import Emitter from "./emitter";
import store from "../redux/store";
import { userSlice } from "../redux/slices/user.slice";

let activeRequests = 0;

/**
 * HTTP client for portal-be Internal Admin API (`/internal/v1/*`).
 * Response shape: `{ success, data?, message?, error? }` (not the main API wrapper).
 */
const request = async (type, url, payload = null, isBackground = false, silent = false) => {
  if (!isBackground) {
    Emitter.emit("AJAX_SEND");
  }

  const token = store.getState()?.currentUser?.tokens?.accessToken;

  const result = {
    data: null,
    error: null,
    status: null,
    statusText: null,
    message: null,
    success: false,
  };

  try {
    activeRequests += 1;
    const response = await axios({
      method: type,
      url,
      baseURL: `${process.env.REACT_APP_API_SERVER}`,
      data: payload,
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    const body = response.data;
    result.success = body?.success === true;
    result.data = body?.data ?? null;
    result.message = body?.message ?? null;
    result.status = response.status;
    result.statusText = response.statusText;

    if (!result.success) {
      result.error = body?.error ?? { message: "Request failed" };
    }
  } catch (error) {
    const status = error?.response?.status;
    const body = error?.response?.data;

    result.status = status;
    result.statusText = error.response?.statusText;
    result.success = false;
    result.error = body?.error ?? {
      code: "REQUEST_FAILED",
      message: body?.message || error.message || "Request failed",
    };
    result.message = result.error?.message;

    if (status === 401) {
      store.dispatch(userSlice.actions.logout());
      if (process.env.REACT_APP_ENV !== "local") {
        setTimeout(() => {
          window.location.href = process.env.REACT_APP_SSO_LOGOUT;
        }, 1000);
      }
    }
  }

  activeRequests -= 1;
  if (activeRequests === 0) {
    Emitter.emit("AJAX_COMPLETE", result);
  }

  if (!silent && result.message) {
    Emitter.emit("SHOW_NOTIFICATION", {
      message: result.message,
      isError: !result.success,
    });
  } else if (!silent && result.error?.message && !result.success) {
    Emitter.emit("SHOW_NOTIFICATION", {
      message: result.error.message,
      isError: true,
    });
  }

  return result;
};

const internalHttp = {
  get: (url, isBackground = false) => request("get", url, null, isBackground),
  post: (url, payload, options = {}) =>
    request("post", url, payload, false, options.silent === true),
  put: (url, payload) => request("put", url, payload),
  delete: (url) => request("delete", url),
};

export default internalHttp;
